import { render, staticRenderFns } from "./loan.vue?vue&type=template&id=4ad1bbc7&scoped=true"
import script from "./loan.vue?vue&type=script&lang=js"
export * from "./loan.vue?vue&type=script&lang=js"
import style0 from "./loan.vue?vue&type=style&index=0&id=4ad1bbc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1bbc7",
  null
  
)

export default component.exports